import { useLocation } from 'react-router-dom'
import { useAuthStore } from '../../../../../../stores/authStore.js'

/**
 * useSidebarLogic
 *
 * Computes the "Return to Home Screen" target for the OrderEditor sidebar.
 *
 * Prefers the marketplace view the user came from (captured in router state as
 * `from` — only set when navigating from a marketplace URL). When no `from` is
 * present, falls back to the user's theme- and role-aware default category so
 * ModalView never lands on the DrayNow-only `open` category.
 */
export const useSidebarLogic = () => {
  const location = useLocation()
  const getRedirectCategory = useAuthStore((state) => state.getRedirectCategory)

  const returnUrl =
    location.state?.from || `/marketplace/all/${getRedirectCategory()}`

  return { returnUrl }
}
